import { release } from '../resource/ref-count.js';
import { _detachThinInstanceLodMesh } from './thin-instance.js';

function disposeMeshGpu(mesh) {
  if (mesh._disposed) {
    return;
  }
  mesh._disposed = true;
  const g = mesh._gpu;
  if (release(g)) {
    g.positionBuffer.destroy();
    g.normalBuffer.destroy();
    g.uvBuffer.destroy();
    g.indexBuffer.destroy();
    g.tangentBuffer?.destroy();
    g.uv2Buffer?.destroy();
    g.colorBuffer?.destroy();
  }
  const ti = mesh.thinInstances;
  if (ti && release(ti)) {
    _detachThinInstanceLodMesh(mesh);
    ti._gpuBuffer?.destroy();
    ti._colorGpuBuffer?.destroy();
    ti._drawArgsBuffer?.destroy();
  }
  const sk = mesh.skeleton;
  if (sk && release(sk)) {
    sk._disposed = true;
    sk.boneTexture.destroy();
    if (release(sk._skinBuffers)) {
      sk.jointsBuffer.destroy();
      sk.weightsBuffer.destroy();
      sk.joints1Buffer?.destroy();
      sk.weights1Buffer?.destroy();
    }
  }
  const vat = mesh.vat;
  if (vat && release(vat)) {
    vat.settingsBuffer.destroy();
    vat.instanceTexture?.destroy();
    if (release(vat._textureResource)) {
      vat._textureResource.texture.destroy();
    }
    if (release(vat._skinBuffers)) {
      vat.jointsBuffer.destroy();
      vat.weightsBuffer.destroy();
      vat.joints1Buffer?.destroy();
      vat.weights1Buffer?.destroy();
    }
  }
  const mt = mesh.morphTargets;
  if (mt && release(mt)) {
    mt._disposed = true;
    mt.deltasBuffer.destroy();
    mt.weightsBuffer.destroy();
  }
}

export { disposeMeshGpu };
//# sourceMappingURL=mesh-dispose.js.map
